import { render, staticRenderFns } from "./the-nav-dialog-layout.vue?vue&type=template&id=e847c1c2&scoped=true&"
import script from "./the-nav-dialog-layout.vue?vue&type=script&lang=js&"
export * from "./the-nav-dialog-layout.vue?vue&type=script&lang=js&"
import style0 from "./the-nav-dialog-layout.vue?vue&type=style&index=0&id=e847c1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e847c1c2",
  null
  
)

export default component.exports